import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/sandbox/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/org/$org/loop/$loopId/planner/sandbox/table',
      params,
    });
  },
});
